import { ReactComponent as PlayerPlay } from '@assets/components/button/icPlayer-play.svg';
import { ReactComponent as PlayerStop } from '@assets/components/button/icPlayer-stop.svg';
import { Box, Icon, IconButton, SliderValueChangeDetails, VStack } from '@chakra-ui/react';
import { Slider } from '@components/ui/slider';
import { useAppSelector } from '@hooks/redux.hooks';
import { useCameraCommand } from '@hooks/useCameraCommand';
import { selectMonitoringSensorBySensorUniqueKey } from '@redux/situation/monitoring.selectors';
import { useState } from 'react';

import { CameraType } from '@/types/sensor/configuration.types';
import { MonitoringSensorByType } from '@/types/sensor/monitoring.types';

type Props = {
  uniqueKey: string;
};

export default function ({ uniqueKey }: Readonly<Props>) {
  const monitoringSensor = useAppSelector((state) =>
    selectMonitoringSensorBySensorUniqueKey(state, false, uniqueKey),
  ) as MonitoringSensorByType<CameraType>;
  const { configuration, status } = monitoringSensor;
  const useCamera = useCameraCommand({ monitoringSensor });
  const [simpleRoundSpeed, setSimpleRoundSpeed] = useState<number[]>(
    status?.simpleRoundSpeed != null ? [status.simpleRoundSpeed] : [1],
  );

  function startSimpleRound(speed?: number[] | null) {
    if (speed) {
      useCamera.simpleRound(true, speed.at(0));
    }
  }

  function stopSimpleRound() {
    useCamera.simpleRound(false);
  }

  return (
    <VStack width="100%" padding={4} gap={5} userSelect="none">
      <Box width="100%" height="100%">
        <Slider
          width="100%"
          showValue
          min={configuration.vxMin}
          max={6}
          step={0.05}
          value={simpleRoundSpeed}
          onValueChange={(speed: SliderValueChangeDetails) => {
            setSimpleRoundSpeed(speed.value);
            if (status?.roundOn) {
              startSimpleRound(speed.value);
            }
          }}
        />
      </Box>
      {status?.roundOn ? (
        <IconButton
          onClick={() => {
            stopSimpleRound();
          }}
          backgroundColor="transparent"
          width="40px"
          height="40px"
          aria-label="stop"
          variant="player"
        >
          <Icon as={PlayerStop} boxSize="40px" />
        </IconButton>
      ) : (
        <IconButton
          onClick={() => {
            startSimpleRound(simpleRoundSpeed);
          }}
          backgroundColor="transparent"
          width="40px"
          height="40px"
          aria-label="play"
          variant="player"
        >
          <Icon as={PlayerPlay} boxSize="40px" />
        </IconButton>
      )}
    </VStack>
  );
}
